import request from '@/libs/request';

/**
 * @description 上传
 * @param {Object} param data {Object} 传值参数
 */
export function submitGuest(data) {
  return request({
    url: '/submit_guest',
    method: 'post',
    data,
  });
}
export function submitGuestPay(data) {
  return request({
    url: '/submit_pay',
    method: 'post',
    data,
  });
}
export function getGuestInfo(data) {
  return request({
    url: '/get_guest_info',
    method: 'post',
    data,
  });
}


// WEBPACK FOOTER //
// ./src/api/guest.js